import { render, staticRenderFns } from "./pointWindow.vue?vue&type=template&id=03f270ec&scoped=true"
import script from "./pointWindow.vue?vue&type=script&lang=js"
export * from "./pointWindow.vue?vue&type=script&lang=js"
import style0 from "./pointWindow.vue?vue&type=style&index=0&id=03f270ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f270ec",
  null
  
)

export default component.exports